import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { PaymentPlan } from '@/modules/paymentPlan/paymentPlan.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createPaymentPlan = () => ({
  body: generateJoiValidation(PaymentPlan.schema),
});

export const updatePaymentPlan = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(PaymentPlan.schema, true),
});

export const getPaymentPlan = {
  query: Joi.object().keys({
    name: Joi.string(),
    paymentPlan: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    project: Joi.string(),
    status: Joi.string(),
  }),
};

export const getPaymentPlanById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deletePaymentPlanById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
